import React, { useState, useEffect } from 'react';
import { Booking } from '../../pages';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { object, string, number, boolean } from 'yup';
import { BookingController } from '../../controllers';
import { bookingStore, userStore } from '../../stores';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const BookingContainer = () => {
	const [viewLinks, setViewLinks] = useState(false);
	const [viewBookings, setViewBookings] = useState(true);
	const [createLinks, setCreateLinks] = useState(false);
	const [loading, setLoading] = useState(true);
	const [editLink, setEditLink] = useState(false);
	const [deleteLink, setDeleteLink] = useState(false);
	const [showSurvey, setShowSurvey] = useState(false);

	useEffect(() => {
		const allCreatedLinks = async () => {
			setLoading(true);
			await BookingController.getAllBookings();
			await BookingController.getAllBookingLinks();
			setLoading(false);
		};

		allCreatedLinks();
	}, []);

	const goToViewLinks = () => {
		setViewLinks(true);
		setViewBookings(false);
		setCreateLinks(false);
		setEditLink(false);
	};

	const refresh = async () => {
		setLoading(true);
		await BookingController.getAllBookings();
		setLoading(false);
	};

	const goToCreateLinks = () => {
		setCreateLinks(true);
		setViewLinks(false);
		setEditLink(false);
		setViewBookings(false);
	};

	const goToViewBookings = () => {
		setViewLinks(false);
		setViewBookings(true);
		setCreateLinks(false);
	};

	const goToEditLinks = link => {
		setViewLinks(false);
		setViewBookings(false);
		setEditLink(true);
		bookingStore.setSelectedBookingLink(link);
	};

	const goToDeleteLink = link => {
		bookingStore.setSelectedBookingLink(link);
		setDeleteLink(true);
	};

	const copySelectedLink = link => {
		navigator.clipboard.writeText(link.bookingUrl);
		MimaToastUtil.success({
			message: 'Copied!',
		});
	};

	const cancelEdit = () => {
		setViewLinks(true);
		setViewBookings(false);
		setEditLink(false);
		bookingStore.setSelectedBookingLink();
	};

	const closeModal = () => {
		bookingStore.setSelectedBooking();
		setDeleteLink(false);
	};

	const paymentLinkNav = [
		{
			title: 'Bookings',
			clickAction: goToViewBookings,
			activeState: viewBookings,
		},
		{
			title: 'View Links',
			clickAction: goToViewLinks,
			activeState: viewLinks,
		},
		{
			title: 'Create Booking Link',
			clickAction: goToCreateLinks,
			activeState: createLinks,
		},
	];

	const validationSchema = () => {
		return object({
			title: string().required('Enter a Booking Link Name'),
			description: string().required('Enter the Booking Link description'),
			durationInMinutes: number(
				'enter the number minutes for each session'
			).required(),
			acceptPhoneNumber: boolean().required(
				'Should booking link require phone numbers?'
			),
			availableWeekends: boolean().required(
				'Do you accept bookings in the weekends?'
			),
			acceptPartPayment: boolean().required(
				'Should booking link accept part booking?'
			),
			currencyCode: string().required('Select Currency'),
			chargeSplit: string().required('Select How you want to split charges'),
			minDeposit: number('enter a number'),
			amount: number('enter a number').required('Amount is required'),
		});
	};

	const handleOptionSelect = (_id, link, option) => {
		if (option.value === 'Edit Link') {
			goToEditLinks(link);
		} else if (option.value === 'Deactivate Link') {
			goToDeleteLink(link);
		} else if (option.value === 'Copy Link Url') {
			copySelectedLink(link);
		}
	};

	return (
		<Booking
			viewLinks={viewLinks}
			viewBookings={viewBookings}
			createLinks={createLinks}
			bookingNav={paymentLinkNav}
			validationSchema={validationSchema}
			loading={loading}
			refresh={refresh}
			editLink={editLink}
			setCreateLinks={setCreateLinks}
			setEditLink={setEditLink}
			handleOptionSelect={handleOptionSelect}
			closeModal={closeModal}
			deleteLink={deleteLink}
			cancelEdit={cancelEdit}
			goToCreateLinks={goToCreateLinks}
			showSurvey={showSurvey}
			setShowSurvey={setShowSurvey}
			setViewBookings={setViewBookings}
			setViewLinks={setViewLinks}
		/>
	);
};

export default BookingContainer;
